import * as Sentry from "@sentry/browser";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import api from "../../../api";
import urls from "../../../urls";
import { queryWithPollResponse } from "../../../utils/api-utils";
import type { CreatedGenerator } from "../../../utils/backend-types";

export function useImportGeneratorFromMastr(
  taskId: string,
  options?: Partial<UseQueryOptions<CreatedGenerator>>
) {
  return useQuery({
    queryKey: ["generator-from-mastr", { taskId }],
    queryFn: () => fetchGeneratorFromMastr(taskId),
    ...options
  });
}

async function fetchGeneratorFromMastr(taskId: string) {
  const url = urls.api.getCreatedGeneratorsFromMastr(taskId);

  const response = await queryWithPollResponse<CreatedGenerator>(() =>
    api.get(url)
  );

  if (!response.data) {
    Sentry.captureMessage(
      `useImportGeneratorFromMastr: response missing data for taskId ${taskId}`
    );
    throw new Error(t("errors.ServerError"));
  }

  return response.data;
}
